module.exports = __webpack_public_path__ + "img/logo.94813b71.png";